import Modal from "@/common/elements/Modal";
import AddCharges, { MODE } from "../AddCharges";
import { useEffect, useRef, useState } from "react";
import {
  getBookingsByNumberUtil,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { setBookings, setLastBookingsFromAPI } from "@/slices/bookingsSlice";
import { v4 as uuidV4 } from "uuid";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import notificationService from "@/util/notificationService";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const EditChargesModal = ({
  show,
  onHide,
  isEdit,
  selectChargeData = null,
  chargesData = [],
  bookingBails,
  startingPoint,
}) => {
  const dispatch = useDispatch();
  const { bookings, irisSearchId, irisEnrolleId } = useSelector(
    (state) => state?.bookings
  );
  const chargeFormRef = useRef();
  const [user, setUser] = useState(null);
  const [isAPICall, setisAPICall] = useState(false);
  const [courtListsData, setCourtListsData] = useState([]);
  const [isDisabled, setDisabled] = useState(false);
  const fullSearch = useSelector((state) => state.fullSearch);
  useEffect(() => {
    const loginUser = JSON.parse(localStorage.getItem("userDetails"));
    if (isNonEmptyVariable(loginUser)) {
      setUser(loginUser);
    }
  }, []);

  useEffect(() => {
    if (!isNonEmptyVariable(selectChargeData)) {
      chargeFormRef?.current?.form?.resetFields();
    }
  }, [selectChargeData]);

  useEffect(() => {
    if (isNonEmptyVariable(selectChargeData)) {
      const data = [];
      selectChargeData?.court?.forEach((cl) => {
        const obj = {
          ...cl,
          uuid: uuidV4(),
          courtDateTime:
            isNonEmptyVariable(cl?.courtDate) &&
            isNonEmptyVariable(cl?.courtTime)
              ? cl?.courtDate + " " + cl?.courtTime
              : null,
        };

        data.push(obj);
      });
      setCourtListsData(data);
    } else {
      setCourtListsData([]);
    }
  }, [selectChargeData]);

  const onModalHide = () => {
    onHide();
  };

  const updateCourtListForm = (val) => {
    setCourtListsData(val);
  };

  const onSaveChanges = () => {
    chargeFormRef?.current?.form
      ?.validateFields()
      .then((values) => {
        let chargeUUID = isNonEmptyVariable(selectChargeData?.uuid)
          ? selectChargeData?.uuid
          : uuidV4();
        let bookingBailUuidv4 = isNonEmptyVariable(
          selectChargeData?.bookingBails?.[0]?.bookingBailUuid
        )
          ? selectChargeData?.bookingBails?.[0]?.bookingBailUuid
          : uuidV4();

        if (values?.chooseBailType !== "Attach_existing_bail") {
          bookingBailUuidv4 = uuidV4();
        }

        if (isNonEmptyVariable(values?.deadlineStartDateTime)) {
          values.deadlineStartDateTime =
            values?.deadlineStartDateTime?.format("MM/DD/YYYY HH:mm");
        }

        if (isNonEmptyVariable(values?.deadlineDateTime1Local)) {
          values.deadlineDateTime1 =
            values?.deadlineDateTime1Local?.format("MM/DD/YYYY HH:mm");
        }

        if (isNonEmptyVariable(values?.deadlineDateTime2Local)) {
          values.deadlineDateTime2 =
            values?.deadlineDateTime2Local?.format("MM/DD/YYYY HH:mm");
        }

        if (isNonEmptyVariable(values?.deadlineSatisfiedDateTime1)) {
          values.deadlineSatisfiedDateTime1 =
            values?.deadlineSatisfiedDateTime1?.format("MM/DD/YYYY HH:mm");
        }

        if (isNonEmptyVariable(values?.deadlineSatisfiedDateTime2)) {
          values.deadlineSatisfiedDateTime2 =
            values?.deadlineSatisfiedDateTime2?.format("MM/DD/YYYY HH:mm");
        }

        let obj = {
          ...selectChargeData,
          ...values,
          keyID: !fullSearch ? bookings?.bookingId : null,
          creatorStaffID: !fullSearch ? user?.staffId : null,
          dispositionDate: isNonEmptyVariable(values?.dispositionDate)
            ? dayjs(values?.dispositionDate)?.format("MM/DD/YYYY")
            : null,
          sentenceDate: isNonEmptyVariable(values?.sentenceDate)
            ? dayjs(values?.sentenceDate)?.format("MM/DD/YYYY")
            : null,
          sentenceEndDate: isNonEmptyVariable(values?.sentenceEndDate)
            ? dayjs(values?.sentenceEndDate)?.format("MM/DD/YYYY")
            : null,
          offenseDate: isNonEmptyVariable(values?.offenseDateTime)
            ? dayjs(values?.offenseDateTime)?.format("MM/DD/YYYY")
            : null,
          offenseTime: isNonEmptyVariable(values?.offenseDateTime)
            ? dayjs(values?.offenseDateTime)?.format("HH:mm")
            : null,
          scheduledReleaseDate: isNonEmptyVariable(
            values?.scheduledReleaseDateTime
          )
            ? dayjs(values?.scheduledReleaseDateTime)?.format("MM/DD/YYYY")
            : null,
          scheduledReleaseTime: isNonEmptyVariable(
            values?.scheduledReleaseDateTime
          )
            ? dayjs(values?.scheduledReleaseDateTime)?.format("HH:mm")
            : null,
          sentenceStartDate: isNonEmptyVariable(values?.sentenceStartDateTime)
            ? dayjs(values?.sentenceStartDateTime)?.format("MM/DD/YYYY")
            : null,
          sentenceStartTime: isNonEmptyVariable(values?.sentenceStartDateTime)
            ? dayjs(values?.sentenceStartDateTime)?.format("HH:mm")
            : null,
          clearanceDate: isNonEmptyVariable(values?.clearanceDateTime)
            ? dayjs(values?.clearanceDateTime)?.format("MM/DD/YYYY")
            : null,
          clearanceTime: isNonEmptyVariable(values?.clearanceDateTime)
            ? dayjs(values?.clearanceDateTime)?.format("HH:mm")
            : null,
          deadlineDateTime1: isNonEmptyVariable(values?.deadlineDateTime1)
            ? values?.deadlineDateTime1
            : null,
          deadlineDateTime2: isNonEmptyVariable(values?.deadlineDateTime2)
            ? values?.deadlineDateTime2
            : null,
          deadlineSatisfiedDate1: isNonEmptyVariable(
            values?.deadlineSatisfiedDateTime1
          )
            ? values?.deadlineSatisfiedDateTime1?.split(" ")?.[0]
            : null,
          deadlineSatisfiedTime1: isNonEmptyVariable(
            values?.deadlineSatisfiedDateTime1
          )
            ? values?.deadlineSatisfiedDateTime1?.split(" ")?.[1]
            : null,
          deadlineSatisfiedDate2: isNonEmptyVariable(
            values?.deadlineSatisfiedDateTime2
          )
            ? values?.deadlineSatisfiedDateTime2?.split(" ")?.[0]
            : null,
          deadlineSatisfiedTime2: isNonEmptyVariable(
            values?.deadlineSatisfiedDateTime2
          )
            ? values?.deadlineSatisfiedDateTime2?.split(" ")?.[1]
            : null,
          deadlineStartDate: isNonEmptyVariable(values?.deadlineStartDateTime)
            ? values?.deadlineStartDateTime?.split(" ")?.[0]
            : null,
          deadlineStartTime: isNonEmptyVariable(values?.deadlineStartDateTime)
            ? values?.deadlineStartDateTime?.split(" ")?.[1]
            : null,
        };

        let bookingBail = null;
        if (
          (isNonEmptyVariable(selectChargeData?.bookingBailID) ||
            isNonEmptyVariable(selectChargeData?.bookingBailUuid)) &&
          isNonEmptyVariable(values?.chooseBailType) &&
          values?.chooseBailType === "Attach_existing_bail"
        ) {
          bookingBail = bookingBails?.find(
            (bail) =>
              bail?.bookingBailID === values?.bookingBailUuid ||
              bail?.bookingBailUuid === values?.bookingBailUuid
          );
          bookingBail = {
            ...obj?.bookingBails?.[0],
            courtNumber: isNonEmptyVariable(values?.courtNumber)
              ? values?.courtNumber
              : null,
          };

          if (isNonEmptyVariable(bookingBail?.bookingBailID)) {
            obj.bookingBailID = bookingBail?.bookingBailID;
            obj.bookingID = bookings?.bookingID;
          } else {
            delete obj.bookingBailID;
          }
        }

        if (
          isNonEmptyVariable(obj?.chooseBailType) &&
          obj?.chooseBailType === "new_bail"
        ) {
          delete obj.bookingBailID;
          bookingBail = {
            ...obj?.bookingBails?.[0],
            bookingID: bookings?.bookingID,
            bookingBailUuid: bookingBailUuidv4,
            courtNumber: isNonEmptyVariable(values?.courtNumber)
              ? values?.courtNumber
              : null,
          };
        }

        if (fullSearch) {
          const payload = {
            ...obj,
            court: courtListsData,
            chargeCount: isNaN(parseInt(obj?.chargeCount))
              ? null
              : parseInt(obj?.chargeCount),
            originalChargeCount: isNaN(parseInt(obj?.originalChargeCount))
              ? null
              : parseInt(obj?.originalChargeCount),
            bookingBails: isNonEmptyVariable(bookingBail)
              ? [bookingBail]
              : null,
          };
          const prevBookings = bookings; // <-- from useSelector
          const updated = {
            ...prevBookings,
            charges: [...(prevBookings?.charges || []), payload],
          };
          dispatch(setBookings(updated));
          onModalHide();
          return;
        }

        const payload = {
          ...obj,
          uuid: chargeUUID,
          court: courtListsData,
          chargeCount: parseInt(obj?.chargeCount),
          originalChargeCount: parseInt(obj?.originalChargeCount),
          bookingBailUuid: bookingBailUuidv4,
          bookingBails: isNonEmptyVariable(bookingBail) ? [bookingBail] : null,
        };

        let url = "";
        if (isNonEmptyVariable(selectChargeData)) {
          url = API_ENDPOINTS?.Charge_update;
        } else {
          url = API_ENDPOINTS?.Charge_create;
        }
        setisAPICall(() => true);
        let bpayload = null;

        if (
          isNonEmptyVariable(bookings?.bookingNumber) &&
          isNonEmptyVariable(bookings?.bookingId)
        ) {
          bpayload = {
            bookings: {
              ...bookings,
              bookingId: bookings?.bookingId || null,
              bookingNumber: bookings?.bookingNumber || null,
              bio: bookings?.bio,
              arrestReports: bookings?.arrestReports,
            },
          };
        } else {
          bpayload = {
            bookings: {
              ...bookings,
              transactionId: irisSearchId || 0,
              creatorStaffId: user?.staffId,
              inJail: true,
              user: user?.username,
              isNeedToSubmitGenericInterface: true,
              jackets: [
                {
                  jacketId:
                    bookings?.["Folder ID"] || bookings?.jacketId || null,
                  staffJacket: false,
                  orphanFlag: false,
                },
              ],
              arrestReports: [
                {
                  ...((bookings?.arrestReports && bookings.arrestReports[0]) ||
                    {}),
                  housingAgency: "Jail",
                  custodialAgency: "Jail",
                },
              ],
              bio: [
                {
                  ...((bookings?.bio && bookings.bio[0]) || {}),
                  enrolleeId: bookings.bio[0]?.enrolleeId || irisEnrolleId || 0,
                },
              ],
            },
          };
        }

        api.post(API_ENDPOINTS.bookingsCreate, bpayload).then((resb) => {
          if (resb?.data?.statusCode === 200) {
            if (!isNonEmptyVariable(bpayload?.bookingId)) {
              payload.keyID = resb?.data?.bookingId;
            }

            api
              .post(url, payload)
              .then(async (res) => {
                if (res?.data?.statusCode === 200) {
                  const data = await getBookingsByNumberUtil(
                    resb?.data?.bookingNumber
                  );

                  dispatch(setLastBookingsFromAPI(data));
                  dispatch(
                    setBookings({
                      ...data,
                    })
                  );
                  if (isNonEmptyVariable(selectChargeData)) {
                    notificationService.success(
                      "Success!",
                      "Charges data updated successfully"
                    );
                  } else {
                    notificationService.success(
                      "Success!",
                      "Charge data created successfully"
                    );
                  }

                  onModalHide();
                } else {
                  if (isNonEmptyVariable(selectChargeData)) {
                    notificationService.error(
                      "Failed!",
                      "Charge data updated failed"
                    );
                  } else {
                    notificationService.error(
                      "Failed!",
                      "Charge data created failed"
                    );
                  }
                }
              })
              .catch((err) => {
                console.log(err);
                if (isNonEmptyVariable(selectChargeData)) {
                  notificationService.error(
                    "Failed!",
                    "Charge data updated failed"
                  );
                } else {
                  console.log("Failed to create booking");
                  notificationService.error(
                    "Failed!",
                    "Charge data created failed"
                  );
                }
              })
              .finally(() => {
                setisAPICall(() => false);
              });
          }
        });
      })
      .catch((errorInfo) => {
        chargeFormRef?.current?.form?.scrollToField(
          errorInfo?.errorFields?.[0]?.name,
          {
            behavior: "smooth",
            block: "center",
          }
        );
      });
  };

  useEffect(() => {}, [chargesData]);
  useEffect(() => {
    if (isEdit) {
      let showEdit = hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.MODIFY,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Arrest_Report
      );
      if (showEdit) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    } else {
      setDisabled(false);
    }
  }, [isEdit]);
  return (
    <>
      <Modal
        designPattern="ant"
        show={show}
        onHide={onModalHide}
        header="Charges"
        width="75%"
        handleSubmit={onSaveChanges}
        handleCancel={onModalHide}
        loading={isAPICall}
        scrollable
        hideSubmitButton={isDisabled}
      >
        <AddCharges
          formData={selectChargeData}
          isEdit={isEdit}
          chargeFormRef={chargeFormRef}
          bookingBails={bookingBails}
          updateCourtListForm={updateCourtListForm}
          courtListsData={courtListsData}
          chargesData={chargesData}
          startingPoint={startingPoint}
        />
      </Modal>
    </>
  );
};

export default EditChargesModal;
